import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

enum FunctionCategory {
  LOGIC = 'Logical Functions',
  LOOKUP = 'Lookup and Reference Functions',
  MATH = 'Mathematical Functions',
  STATS = 'Statistical Functions',
  TEXT = 'Text Functions',
  TIMESTAMP = 'Timestamp Functions',
}

export const FUNCTION_ICON: {[K in FunctionCategory]: BenchlingIconName} = {
  [FunctionCategory.LOGIC]: 'boolean',
  [FunctionCategory.LOOKUP]: 'search',
  [FunctionCategory.MATH]: 'number',
  [FunctionCategory.STATS]: 'analyze',
  [FunctionCategory.TEXT]: 'text',
  [FunctionCategory.TIMESTAMP]: 'calendar-days',
};

export default FunctionCategory;
